module.exports = __webpack_public_path__ + "static/bunnyballethamper-e36eddd256c35c9d0c8c82e236fff2f6.jpeg";